import { FullStory, init } from '@fullstory/browser';

const FULLSTORY = {
    VUE_APP_FULL_STORY_ORG: '9NRKK',
    VUE_APP_DEVELOPMENT_MODE: 'Development',
};

export default {
    init(appInfo) {
        const orgId = FULLSTORY.VUE_APP_FULL_STORY_ORG;
        const devMode = appInfo?.newEnvironment === FULLSTORY.VUE_APP_DEVELOPMENT_MODE;

        init({ orgId, devMode });

        const fs = {
            identify: (uid, properties) => FullStory('setIdentity', { uid, properties }),
            event: (name, properties) => FullStory('trackEvent', { name, properties }),
            FullStory,
        };

        fs.identify(`${appInfo?.casUserId}`, {
            email: appInfo?.userEmail,
            appName: appInfo?.appName,
            firstName: appInfo?.userFirstName,
            lastName: appInfo?.userLastName,
            editionName: appInfo?.appEdition,
            environment: appInfo?.newEnvironment,
        });

        return fs;
    },
};
